import { AppErrors } from '../../core/error/appError';
import { ErrorMapper } from '../../core/error/errorMapper';
import { failure, success, type AppResult } from '../../core/result/appResult';
import { isSuccessful, type ApiResponse } from '../api/apiService';

/**
 * Punto único donde las excepciones y los códigos HTTP se convierten en `AppResult`.
 *
 * Todo repositorio pasa por aquí, así que la clasificación de errores es idéntica en toda la
 * aplicación y se prueba una sola vez.
 */
export function currentlyConnected(): boolean {
  // `navigator.onLine` solo es fiable en negativo: `false` significa que no hay interfaz de red,
  // `true` no garantiza salida a internet. Basta para lo que decide aquí: distinguir "sin
  // cobertura" de "el servidor no responde".
  return typeof navigator === 'undefined' || navigator.onLine;
}

export async function execute<T>(block: () => Promise<ApiResponse<T>>): Promise<AppResult<T>> {
  try {
    const response = await block();
    if (isSuccessful(response)) {
      if (response.body !== null) return success(response.body);
      // 204 sin cuerpo es un éxito legítimo para DELETE.
      if (response.status === 204) return success(undefined as T);
      return failure(AppErrors.unknown('Respuesta vacía'));
    }
    return failure(ErrorMapper.fromHttpCode(response.status, response.fields ?? {}));
  } catch (error) {
    return failure(ErrorMapper.fromThrowable(error, currentlyConnected()));
  }
}
